import {ReloadButton,} from '@flexinet/ui-components';

import {Box,} from '@mantine/core';

import {usePaymentProfiles} from '../hooks/usePaymentProfiles.ts';
import {useParams} from "react-router-dom";

export const ReloadRecordsButton = () => {


    const {id: customerId} = useParams()

    const {fetchRecords} = usePaymentProfiles({ customerId: customerId || undefined });

    return (
        <Box mx='s'>
            <ReloadButton onClick={() => fetchRecords()}/>
        </Box>
    );
};
